import { useSelector, shallowEqual } from 'react-redux'

import type { Recipe } from 'reducers/menu-recipes/recipes'
import { getOfferedRecipes } from 'selectors/menu-recipes/getOfferedRecipes'

/**
 * Returns offered recipes
 */
export const useOfferedRecipes = (): Recipe[] => useSelector(getOfferedRecipes, shallowEqual)
